(function(){
    'use strict';

    angular
        .module('elogbooks.user.contact-us')
        .controller('UserContactUsController', UserContactUsController);

    UserContactUsController.inject = ['elbSettings'];

    function UserContactUsController(elbSettings, hasServiceDesk) {
        var vm = this;
        vm.helpdeskSupportNumber = elbSettings.getSetting('general_global_helpdesk_number').value;
        vm.serviceDeskNumber = null;

        if (hasServiceDesk.value) {
            vm.serviceDeskNumber = elbSettings.getSetting('general_helpdesk_number').value;
        }
    }
})();
